export default "__VITE_ASSET__a178d596__"